import { PushpinFilled, PushpinOutlined } from "@ant-design/icons";
import { Empty, Input } from "antd";
import { inicialNome, formatarHoraChat } from "./chatFormat";

export const ChatLista = ({
  conversas,
  filtro,
  onFiltrar,
  onAbrir,
  onFixar,
  onDesafixar,
}) => {
  const termo = (filtro || "").trim().toLowerCase();
  const visiveis = (conversas || []).filter((item) => {
    if (!termo) return true;
    return (item?.contato?.nome || "").toLowerCase().includes(termo);
  });
  const totalFixadas = (conversas || []).filter((item) => item?.fixada).length;
  const limiteAtingido = totalFixadas >= 3;

  return (
    <>
      <div className="chat-busca">
        <Input.Search
          allowClear
          placeholder="Buscar conversa"
          value={filtro}
          onChange={(evento) => onFiltrar(evento.target.value)}
        />
      </div>
      <div className="chat-lista">
        {!visiveis.length && (
          <div className="chat-vazio">
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Nenhuma conversa ainda"
            />
          </div>
        )}
        {visiveis.map((conversa) => {
          const naoLida = Number(conversa.naoLidas) > 0;
          const fixada = Boolean(conversa.fixada);
          const pinDesabilitado = !fixada && limiteAtingido;
          return (
            <div
              key={conversa.codigo}
              className={`chat-item${naoLida ? " chat-item--nao-lida" : ""}${
                fixada ? " chat-item--fixada" : ""
              }`}
            >
              <button
                type="button"
                className="chat-item__abrir"
                onClick={() => onAbrir(conversa)}
              >
                <span className="chat-avatar chat-avatar--lista">
                  {inicialNome(conversa?.contato?.nome)}
                </span>
                <span className="chat-item__texto">
                  <span className="chat-item__topo">
                    <strong>{conversa?.contato?.nome}</strong>
                    <time>{formatarHoraChat(conversa.dataUltimaMensagem)}</time>
                  </span>
                  <span className="chat-item__preview">
                    <span>{conversa.ultimaMensagem || "Toque para conversar"}</span>
                    {naoLida ? <b>{conversa.naoLidas}</b> : null}
                  </span>
                </span>
              </button>
              <button
                type="button"
                className="chat-item__pin"
                disabled={pinDesabilitado}
                aria-label={fixada ? "Desafixar conversa" : "Fixar conversa"}
                title={fixada ? "Desafixar" : "Fixar"}
                onClick={() => (fixada ? onDesafixar(conversa) : onFixar(conversa))}
              >
                {fixada ? <PushpinFilled /> : <PushpinOutlined />}
              </button>
            </div>
          );
        })}
      </div>
    </>
  );
};
